import React, { useContext } from "react";
import { Divider, CircularProgress, Grid, Typography } from "@mui/material";
import { createTheme, ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import LoadingScreen from "components/common/LoadingScreen";
import LockPromptDialog from "components/common/LockPromptDialog";
import { LoginViewContext } from "components/ForgotPswSendEmail.page";
import ForgotpswEmailComponent from "view/mobile/forgotPsw/ForgotpswEmailComponent";
import { useStyles } from "../login/Login.page.style";
import login_bg_mobile from "images/login_bg_mobile.png";
import LoginIcon from "images/loginIcon.png";

const SendEmailMobile = () => {
    const {
        isLoading,
        theme,
        iptNotice,
        usefulInfo,
        logoLink,
        handleSubmit,
        onSubmit,
        control,
        register,
        errors,
        showLockTip,
        setShowLockTip,
        lockTipContent,
    } = useContext(LoginViewContext);

    const classes = useStyles();

    return (
        <div style={{ height: "100%", overflow: "hidden", position: "absolute", top: 0, left: 0, right: 0, bottom: 0 }}>
            <div style={{ height: "100%", overflowY: "auto", overflowX: "hidden" }}>
                <LoadingScreen open={isLoading} />
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={theme}>
                        <Grid container className={classes.fullHeight} flexWrap={"nowrap"}>
                            <Grid container item>
                                <span className={classes.blueRound} />
                                <span className={classes.yellowRound} />
                                <Grid container direction="column">
                                    <Grid container>
                                        <div>
                                            <img width="75%" src={login_bg_mobile} />
                                        </div>
                                    </Grid>
                                    <div>
                                        <a href={logoLink} target={"_blank"}>
                                            <img
                                                style={{ maxWidth: "100%" }}
                                                src={LoginIcon}
                                                alt={"icon"}
                                                className={classes.loginIcon}
                                            />
                                        </a>
                                    </div>

                                    <ForgotpswEmailComponent
                                        register={register}
                                        handleSubmit={handleSubmit}
                                        onSubmit={onSubmit}
                                        control={control}
                                        errors={errors}
                                    />

                                    <Grid container style={{ flex: 1, minHeight: 90, position: "relative" }}>
                                        <div
                                            className={classes.InfoWrapper}
                                            style={{ position: "absolute", top: 0, left: 0, height: "100%" }}
                                        >
                                            <Typography color={"primary"} className={classes.titleFont}>
                                                USEFUL INFORMATION
                                            </Typography>
                                            <Divider className={classes.InfoDivider} />
                                            <div className={classes.InfoContainer}>
                                                {Array.isArray(usefulInfo) &&
                                                    usefulInfo.length > 0 &&
                                                    usefulInfo.map((item, index) => (
                                                        <div
                                                            key={index}
                                                            dangerouslySetInnerHTML={{ __html: item.content }}
                                                        ></div>
                                                    ))}
                                            </div>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </ThemeProvider>
                </StyledEngineProvider>

                
                <LockPromptDialog open={showLockTip} onClose={() => setShowLockTip(false)} content={lockTipContent} />
            </div>
        </div>
    );
};

export default SendEmailMobile;
